import React from "react";
import ButtonText from "../Typography/ButtonText";

/** CTA padding (xs/sm → md/lg @768px → xl/2xl @1280px), mobile-first */
const CTA_PAD_L =
  "px-[20px] py-[10px] md:px-[24px] md:py-[11px] xl:px-[28px] xl:py-[11px]";
const CTA_PAD_M =
  "px-[18px] py-[9px] md:px-[20px] md:py-[10px] xl:px-[22px] xl:py-[11px]";
const CTA_PAD_S =
  "px-[14px] py-[8px] md:px-[16px] md:py-[9px] xl:px-[16px] xl:py-[9px]";

/** Line height (spec matrix) */
const CTA_LEAD_L = "leading-[16px] xl:leading-[18px]";
const CTA_LEAD_M = "leading-[16px] xl:leading-[18px]";
const CTA_LEAD_S = "leading-[16px] xl:leading-[18px]";

/** Content-based height with min-height guardrails (spec §4–5) */
const CTA_BOX_L =
  "w-auto max-w-full min-w-[128px] min-h-[38px] md:min-w-[136px] md:min-h-[40px] xl:min-w-[144px] xl:min-h-[42px]";
const CTA_BOX_M =
  "w-auto max-w-full min-w-[96px] min-h-[36px] md:min-w-[104px] md:min-h-[38px] xl:min-w-[112px] xl:min-h-[40px]";
const CTA_BOX_S =
  "w-auto max-w-full min-w-[64px] min-h-[34px] md:min-w-[72px] md:min-h-[36px] xl:min-w-[80px] xl:min-h-[38px]";

const CTA_SHELL =
  "box-border h-auto inline-flex items-center justify-center outline-none focus-visible:ring-2 focus-visible:ring-primaryblue focus-visible:ring-offset-1";

const CTA_BORDER_SECONDARY = "border border-mediumgray hover:border-brightblue";

const MainButton = ({
  variant,
  children,
  className = "",
  onClick,
  type = "button",
  disabled,
  form,
}) => {
  return (
    <>
      {/* Latest Buttons Started*/}
      {/* extralarge alias — renders Large per CTA spec (Extra Large not used) */}
      {variant === "extralarge" && (
        <button
          disabled={disabled}
          onClick={onClick}
          type={type}
          className={`
    ${className} cta-large-primary ${CTA_SHELL} relative group overflow-hidden rounded-[999px] ${CTA_PAD_L} ${CTA_LEAD_L} ${CTA_BOX_L} bg-primaryblue text-white text-center disabled:hidden`}
        >
          <span className="rounded-t-full group-hover:rounded-t-none absolute bottom-0 left-1/2 group-hover:left-0 flex w-[1px] group-hover:w-full h-0 mb-0 transition-all duration-300 ease-out transform translate-y-0 bg-offblack group-hover:h-[150%]"></span>
          <span className="relative group-hover:text-white flex items-center justify-center transition-all duration-300">
            <ButtonText variant={"PrimaryText"}>{children}</ButtonText>
          </span>
        </button>
      )}
      {/* Large filled button for Desktop, Tabs & Mobiles */}
      {variant === "large" && (
        <button
          disabled={disabled}
          onClick={onClick}
          type={type}
          className={`
    ${className} cta-large-primary ${CTA_SHELL} relative group overflow-hidden rounded-[999px] ${CTA_PAD_L} ${CTA_LEAD_L} ${CTA_BOX_L} bg-primaryblue text-white text-center disabled:hidden`}
        >
          <span className="rounded-t-full group-hover:rounded-t-none absolute bottom-0 left-1/2 group-hover:left-0 flex w-[1px] group-hover:w-full h-0 mb-0 transition-all duration-300 ease-out transform translate-y-0 bg-offblack group-hover:h-[150%]"></span>
          <span className="relative group-hover:text-white flex items-center justify-center transition-all duration-300">
            <ButtonText variant={"PrimaryText"}>{children}</ButtonText>
          </span>
        </button>
      )}
      {/* Medium filled button for Desktop, Tabs & Mobiles */}
      {variant === "medium" && (
        <button
          disabled={disabled}
          onClick={onClick}
          type={type}
          className={`
          ${className} cta-medium-primary ${CTA_SHELL} relative group overflow-hidden rounded-[999px] ${CTA_PAD_M} ${CTA_LEAD_M} ${CTA_BOX_M} bg-primaryblue text-white text-center disabled:hidden`}
        >
          <span className="rounded-t-full group-hover:rounded-t-none absolute bottom-0 left-1/2 group-hover:left-0 flex w-[1px] group-hover:w-full h-0 mb-0 transition-all duration-300 ease-out transform translate-y-0 bg-offblack group-hover:h-[150%]"></span>
          <span className="relative group-hover:text-white flex items-center justify-center transition-all duration-300">
            <ButtonText variant={"PrimaryText"}>{children}</ButtonText>
          </span>
        </button>
      )}
      {/* Small filled button for Desktop, Tabs & Mobiles */}
      {(variant === "small" || variant === "primarysmall") && (
        <button
          form={form}
          disabled={disabled}
          onClick={onClick}
          type={type}
          className={`
          ${className} cta-small-primary ${CTA_SHELL} relative group overflow-hidden rounded-[999px] ${CTA_PAD_S} ${CTA_LEAD_S} ${CTA_BOX_S} bg-primaryblue text-white text-center disabled:hidden`}
        >
          <span className="rounded-t-full group-hover:rounded-t-none absolute bottom-0 left-1/2 group-hover:left-0 flex w-[1px] group-hover:w-full h-0 mb-0 transition-all duration-300 ease-out transform translate-y-0 bg-offblack group-hover:h-[150%]"></span>
          <span className="relative group-hover:text-white flex items-center justify-center transition-all duration-300">
            <ButtonText variant={"PrimaryText"}>{children}</ButtonText>
          </span>
        </button>
      )}
      {/* filled buttons with justify between text */}
      {variant === "largebetween" && (
        <button
          disabled={disabled}
          onClick={onClick}
          type={type}
          className={`
    ${className} cta-large-between-primary ${CTA_SHELL} relative group overflow-hidden rounded-[999px] ${CTA_PAD_L} ${CTA_LEAD_L} ${CTA_BOX_L} bg-primaryblue text-white text-center disabled:hidden`}
        >
          <ButtonText variant={"PrimaryText"}>
            <span className="rounded-t-full group-hover:rounded-t-none absolute bottom-0 left-1/2 group-hover:left-0 flex w-[1px] group-hover:w-full h-0 mb-0 transition-all duration-300 ease-out transform translate-y-0 bg-offblack group-hover:h-[150%]"></span>
            <span className="relative group-hover:text-white flex items-center justify-between gap-2 px-0 transition-all duration-300">
              {children}
            </span>
          </ButtonText>
        </button>
      )}
      {/* Medium filled button for Desktop, Tabs & Mobiles */}
      {variant === "mediumbetween" && (
        <button
          disabled={disabled}
          onClick={onClick}
          type={type}
          className={`
          ${className} cta-medium-between-primary ${CTA_SHELL} relative group overflow-hidden rounded-[999px] ${CTA_PAD_M} ${CTA_LEAD_M} ${CTA_BOX_M} bg-primaryblue text-white text-center disabled:hidden`}
        >
          <ButtonText variant={"PrimaryText"}>
            <span className="rounded-t-full group-hover:rounded-t-none absolute bottom-0 left-1/2 group-hover:left-0 flex w-[1px] group-hover:w-full h-0 mb-0 transition-all duration-300 ease-out transform translate-y-0 bg-offblack group-hover:h-[150%]"></span>
            <span className="relative group-hover:text-white flex items-center justify-between gap-2 px-0 transition-all duration-300">
              {children}
            </span>
          </ButtonText>
        </button>
      )}
      {/* Small filled button for Desktop, Tabs & Mobiles */}
      {variant === "smallbetween" && (
        <button
          disabled={disabled}
          onClick={onClick}
          type={type}
          className={`
          ${className} cta-small-between-primary ${CTA_SHELL} relative group overflow-hidden rounded-[999px] ${CTA_PAD_S} ${CTA_LEAD_S} ${CTA_BOX_S} bg-primaryblue text-white text-center disabled:hidden`}
        >
          <ButtonText variant={"PrimaryText"}>
            <span className="rounded-t-full group-hover:rounded-t-none absolute bottom-0 left-1/2 group-hover:left-0 flex w-[1px] group-hover:w-full h-0 mb-0 transition-all duration-300 ease-out transform translate-y-0 bg-offblack group-hover:h-[150%]"></span>
            <span className="relative group-hover:text-white flex items-center justify-between gap-2 px-0 transition-all duration-300">
              {children}
            </span>
          </ButtonText>
        </button>
      )}

      {/* Large outlined button for Desktop, Tabs & Mobiles */}
      {variant === "outlinelarge" && (
        <button
          disabled={disabled}
          onClick={onClick}
          type={type}
          className={`
          ${className} cta-large-secondary ${CTA_SHELL} relative group overflow-hidden rounded-[999px] ${CTA_PAD_L} ${CTA_LEAD_L} ${CTA_BOX_L} ${CTA_BORDER_SECONDARY} text-offblack text-center disabled:hidden`}
        >
          <span className="rounded-t-full group-hover:rounded-t-none absolute bottom-0 left-1/2 group-hover:left-0 flex w-[1px] group-hover:w-full h-0 mb-0 transition-all duration-300 ease-out transform translate-y-0 bg-brightblue group-hover:h-[150%]"></span>
          <span className="relative group-hover:text-white flex items-center justify-center transition-all duration-300">
            <ButtonText variant={"SecondaryButton"}>{children}</ButtonText>
          </span>
        </button>
      )}
      {/* Medium outlined button for Desktop, Tabs & Mobiles */}
      {variant === "outlinemedium" && (
        <button
          disabled={disabled}
          onClick={onClick}
          type={type}
          className={`
          ${className} cta-medium-secondary ${CTA_SHELL} relative group overflow-hidden rounded-[999px] ${CTA_PAD_M} ${CTA_LEAD_M} ${CTA_BOX_M} ${CTA_BORDER_SECONDARY} text-offblack text-center disabled:hidden`}
        >
          <span className="rounded-t-full group-hover:rounded-t-none absolute bottom-0 left-1/2 group-hover:left-0 flex w-[1px] group-hover:w-full h-0 mb-0 transition-all duration-300 ease-out transform translate-y-0 bg-brightblue group-hover:h-[150%]"></span>
          <span className="relative group-hover:text-white flex items-center justify-center transition-all duration-300">
            <ButtonText variant={"SecondaryButton"}>{children}</ButtonText>
          </span>
        </button>
      )}
      {/* Small outlined button for Desktop, Tabs & Mobiles */}
      {variant === "outlinesmall" && (
        <button
          disabled={disabled}
          onClick={onClick}
          type={type}
          className={`
          ${className} cta-small-secondary ${CTA_SHELL} relative group overflow-hidden rounded-[999px] ${CTA_PAD_S} ${CTA_LEAD_S} ${CTA_BOX_S} ${CTA_BORDER_SECONDARY} text-offblack text-center disabled:hidden`}
        >
          <span className="rounded-t-full group-hover:rounded-t-none absolute bottom-0 left-1/2 group-hover:left-0 flex w-[1px] group-hover:w-full h-0 mb-0 transition-all duration-300 ease-out transform translate-y-0 bg-brightblue group-hover:h-[150%]"></span>
          <span className="relative group-hover:text-white flex items-center justify-center transition-all duration-300">
            <ButtonText variant={"SecondaryButton"}>{children}</ButtonText>
          </span>
        </button>
      )}
      {variant === "outlineextralargebetween" && (
        <button
          disabled={disabled}
          onClick={onClick}
          type={type}
          className={`
          ${className} cta-large-between-secondary ${CTA_SHELL} relative group overflow-hidden rounded-[999px] ${CTA_PAD_L} ${CTA_LEAD_L} ${CTA_BOX_L} ${CTA_BORDER_SECONDARY} text-offblack text-center disabled:hidden`}
        >
          <ButtonText variant={"SecondaryButton"}>
            <span className="rounded-t-full group-hover:rounded-t-none absolute bottom-0 left-1/2 group-hover:left-0 flex w-[1px] group-hover:w-full h-0 mb-0 transition-all duration-300 ease-out transform translate-y-0 bg-brightblue group-hover:h-[150%]"></span>
            <span className="relative group-hover:text-white flex items-center justify-between gap-2 px-0 transition-all duration-300">
              {children}
            </span>
          </ButtonText>
        </button>
      )}
      {variant === "outlinelargebetween" && (
        <button
          disabled={disabled}
          onClick={onClick}
          type={type}
          className={`
          ${className} cta-large-between-secondary ${CTA_SHELL} relative group overflow-hidden rounded-[999px] ${CTA_PAD_L} ${CTA_LEAD_L} ${CTA_BOX_L} ${CTA_BORDER_SECONDARY} text-offblack text-center disabled:hidden`}
        >
          <ButtonText variant={"SecondaryButton"}>
            <span className="rounded-t-full group-hover:rounded-t-none absolute bottom-0 left-1/2 group-hover:left-0 flex w-[1px] group-hover:w-full h-0 mb-0 transition-all duration-300 ease-out transform translate-y-0 bg-brightblue group-hover:h-[150%]"></span>
            <span className="relative group-hover:text-white flex items-center justify-between gap-2 px-0 transition-all duration-300">
              {children}
            </span>
          </ButtonText>
        </button>
      )}
      {variant === "outlinemediumbetween" && (
        <button
          disabled={disabled}
          onClick={onClick}
          type={type}
          className={`
          ${className} cta-medium-between-secondary ${CTA_SHELL} relative group overflow-hidden rounded-[999px] ${CTA_PAD_M} ${CTA_LEAD_M} ${CTA_BOX_M} ${CTA_BORDER_SECONDARY} text-offblack text-center disabled:hidden`}
        >
          <ButtonText variant={"SecondaryButton"}>
            <span className="rounded-t-full group-hover:rounded-t-none absolute bottom-0 left-1/2 group-hover:left-0 flex w-[1px] group-hover:w-full h-0 mb-0 transition-all duration-300 ease-out transform translate-y-0 bg-brightblue group-hover:h-[150%]"></span>
            <span className="relative group-hover:text-white flex items-center justify-between gap-2 px-0 transition-all duration-300">
              {children}
            </span>
          </ButtonText>
        </button>
      )}
      {variant === "outlinesmallbetween" && (
        <button
          disabled={disabled}
          onClick={onClick}
          type={type}
          className={`
          ${className} cta-small-between-secondary ${CTA_SHELL} relative group overflow-hidden rounded-[999px] ${CTA_PAD_S} ${CTA_LEAD_S} ${CTA_BOX_S} ${CTA_BORDER_SECONDARY} text-offblack text-center disabled:hidden`}
        >
          <ButtonText variant={"SecondaryButton"}>
            <span className="rounded-t-full group-hover:rounded-t-none absolute bottom-0 left-1/2 group-hover:left-0 flex w-[1px] group-hover:w-full h-0 mb-0 transition-all duration-300 ease-out transform translate-y-0 bg-brightblue group-hover:h-[150%]"></span>
            <span className="relative group-hover:text-white flex items-center justify-between gap-2 px-0 transition-all duration-300">
              {children}
            </span>
          </ButtonText>
        </button>
      )}
      {variant === "facebook" && (
        <button
          disabled={disabled}
          onClick={onClick}
          type={type}
          className={`
          ${className} cta-large-primary ${CTA_SHELL} relative group overflow-hidden rounded-[999px] ${CTA_PAD_L} ${CTA_LEAD_L} ${CTA_BOX_L} text-white bg-[#1877F2] text-center disabled:hidden`}
        >
          <span className="rounded-t-full group-hover:rounded-t-none absolute bottom-0 left-1/2 group-hover:left-0 flex w-[1px] group-hover:w-full h-0 mb-0 transition-all duration-300 ease-out transform translate-y-0 bg-offblack group-hover:h-[150%]"></span>
          <span className="relative group-hover:text-white flex items-center justify-center">
            <ButtonText variant={"PrimaryText"}>{children}</ButtonText>
          </span>
        </button>
      )}
      {variant === "loginSignup" && (
        <button
          disabled={disabled}
          onClick={onClick}
          type={type}
          className={`
          ${className} cta-extra-small-primary ${CTA_SHELL} relative group overflow-hidden rounded-[4px] w-[145px] min-h-[40px] md:w-[175px] md:min-h-[44px] xl:w-[190px] xl:min-h-[48px] h-auto max-w-full text-offblack text-center disabled:hidden border border-solid border-mediumgray transition-all duration-300 ease-out hover:border-primaryblue`}
        >
          <span className="rounded-t-full group-hover:rounded-t-none absolute bottom-0 left-1/2 group-hover:left-0 flex w-[1px] group-hover:w-full h-0 mb-0 transition-all duration-300 ease-out transform translate-y-0 bg-primaryblue group-hover:h-[150%]"></span>
          <span className="relative group-hover:text-white align-middle justify-center">
            <ButtonText variant={"PrimaryText"} className="flex items-center align-middle justify-center">{children}</ButtonText>
          </span>
        </button>
      )}
      {/* Special red button  */}
      {variant === "specialredbutton" && (
        <button
          disabled={disabled}
          onClick={onClick}
          type={type}
          className={`
          ${className} cta-large-primary ${CTA_SHELL} relative group overflow-hidden rounded-[999px] ${CTA_PAD_L} ${CTA_LEAD_L} ${CTA_BOX_L} text-white bg-alertred text-center disabled:hidden`}
        >
          <span className="rounded-t-full group-hover:rounded-t-none absolute bottom-0 left-1/2 group-hover:left-0 flex w-[1px] group-hover:w-full h-0 mb-0 transition-all duration-300 ease-out transform translate-y-0 bg-offblack group-hover:h-[150%]"></span>
          <span className="relative group-hover:text-white flex items-center justify-center">
            <ButtonText variant={"PrimaryText"}>{children}</ButtonText>
          </span>
        </button>
      )}
      {variant === "specialredbuttonmedium" && (
        <button
          disabled={disabled}
          onClick={onClick}
          type={type}
          className={`
          ${className} cta-medium-primary ${CTA_SHELL} relative group overflow-hidden rounded-[999px] ${CTA_PAD_M} ${CTA_LEAD_M} ${CTA_BOX_M} text-white bg-alertred text-center disabled:hidden`}
        >
          <span className="rounded-t-full group-hover:rounded-t-none absolute bottom-0 left-1/2 group-hover:left-0 flex w-[1px] group-hover:w-full h-0 mb-0 transition-all duration-300 ease-out transform translate-y-0 bg-offblack group-hover:h-[150%]"></span>
          <span className="relative group-hover:text-white flex items-center justify-center">
            <ButtonText variant={"PrimaryText"}>{children}</ButtonText>
          </span>
        </button>
      )}
      {/* Auto width filled button */}
      {variant === "auto" && (
        <button
          disabled={disabled}
          onClick={onClick}
          type={type}
          className={`
          ${className} cta-auto-primary ${CTA_SHELL} relative group overflow-hidden rounded-[999px] w-auto max-w-full ${CTA_PAD_M} ${CTA_LEAD_M} min-h-[36px] md:min-h-[38px] xl:min-h-[40px] bg-primaryblue text-white text-center disabled:hidden`}
        >
          <span className="rounded-t-full group-hover:rounded-t-none absolute bottom-0 left-1/2 group-hover:left-0 flex w-[1px] group-hover:w-full h-0 mb-0 transition-all duration-300 ease-out transform translate-y-0 bg-offblack group-hover:h-[150%]"></span>
          <span className="relative group-hover:text-white flex items-center justify-center transition-all duration-300">
            <ButtonText variant={"PrimaryText"}>{children}</ButtonText>
          </span>
        </button>
      )}
      {/* Plain text button — primary-blue label, no pill fill (matches inline link emphasis without underline) */}
      {variant === "text" && (
        <button
          disabled={disabled}
          onClick={onClick}
          type={type}
          form={form}
          className={`
          ${className} cta-link ${CTA_SHELL} relative inline-flex items-center justify-center bg-transparent border-0 p-0 h-auto min-h-0 w-auto min-w-0 max-w-full rounded-none shadow-none text-primaryblue hover:no-underline disabled:opacity-50 disabled:cursor-not-allowed`}
        >
          <span className="relative flex items-center justify-center text-primaryblue">
            <ButtonText variant={"SecondaryText"} className="text-primaryblue">
              {children}
            </ButtonText>
          </span>
        </button>
      )}
      {/* Latest Buttons Ended*/}
    </>
  );
};
export default MainButton;

// --- Tailwind CTA Primary Button Sizes Demo ---
// MainButtons component: renders a single button with customizable size (variant), type, click handler, disabled state, and additional classes.
// Props:
//   - children: node (button label/content)
//   - variant: string (one of 'small', 'medium', 'large', 'extra-large', default: 'medium')
//   - className: string (additional classes to apply)
//   - type: string (button type, e.g. 'button', 'submit', default: 'button')
//   - onClick: function (click handler)
//   - disabled: boolean (disabled state)

const sizeClassMap = {
  small: "cta-small-primary",
  medium: "cta-medium-primary",
  large: "cta-large-primary",
  "extra-large": "cta-large-primary",
};

const sizePaddingMap = {
  small: CTA_PAD_S,
  medium: CTA_PAD_M,
  large: CTA_PAD_L,
  "extra-large": CTA_PAD_L,
};

const sizeLeadMap = {
  small: CTA_LEAD_S,
  medium: CTA_LEAD_M,
  large: CTA_LEAD_L,
  "extra-large": CTA_LEAD_L,
};

const sizeBoxMap = {
  small: CTA_BOX_S,
  medium: CTA_BOX_M,
  large: CTA_BOX_L,
  "extra-large": CTA_BOX_L,
};

export const MainButtons = ({
  children,
  variant = 'medium',
  className = '',
  type = 'button',
  onClick,
  disabled = false,
}) => {
  const sizeClass = sizeClassMap[variant] || sizeClassMap['medium'];
  const padClass = sizePaddingMap[variant] || sizePaddingMap['medium'];
  const leadClass = sizeLeadMap[variant] || sizeLeadMap['medium'];
  const boxClass = sizeBoxMap[variant] || sizeBoxMap['medium'];
  return (
    <button
      className={`${sizeClass} ${CTA_SHELL} ${padClass} ${leadClass} ${boxClass} bg-primaryblue text-white rounded-[999px] ${className}`}
      type={type}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

/*
Button Size Documentation

Extra Large Buttons
- xs (416px): width  [260px] height  [50px]
- sm (640px): width  [280px] height  [54px]
- md (768px): width  [300px] height  [54px]
- lg (900px): width  [250px] height  [54px]
- xl (1280px): width  [300px] height  [54px]
- 2xl (1536px): width  [300px] height  [54px]
- 3xl (1920px): width  [300px] height  [54px]
- 2k (2240px): width  [300px] height  [54px]
- 4k (2560px+): width  [300px] height  [54px]

Large Buttons
- xs (416px): width  [170px] height  [48px]
- sm (640px): width  [180px] height  [50px]
- md (768px): width  [190px] height  [54px]
- lg (900px): width  [190px] height  [54px]
- xl (1280px): width  [190px] height  [54px]
- 2xl (1536px): width  [190px] height  [54px]
- 3xl (1920px): width  [190px] height  [54px]
- 2k (2240px): width  [190px] height  [54px]
- 4k (2560px+): width  [190px] height  [54px]

Medium Buttons
- xs (416px): width  [120px] height  [46px]
- sm (640px): width  [130px] height  [48px]
- md (768px): width  [140px] height  [52px]
- lg (900px): width  [140px] height  [52px]
- xl (1280px): width  [140px] height  [52px]
- 2xl (1536px): width  [140px] height  [52px]
- 3xl (1920px): width  [140px] height  [52px]
- 2k (2240px): width  [140px] height  [52px]
- 4k (2560px+): width  [140px] height  [52px]

Small Buttons
- xs (416px): width  [90px] height  [44px]
- sm (640px): width  [100px] height  [46px]
- md (768px): width  [110px] height  [50px]
- lg (900px): width  [110px] height  [50px]
- xl (1280px): width  [110px] height  [50px]
- 2xl (1536px): width  [110px] height  [50px]
- 3xl (1920px): width  [110px] height  [50px]
- 2k (2240px): width  [110px] height  [50px]
- 4k (2560px+): width  [110px] height  [50px]

Auto Width Button
- xs (416px): height  [48px] (width auto)
- sm (640px): height  [50px] (width auto)
- md (768px): height  [54px] (width auto)
- lg (900px): height  [54px] (width auto)
- xl (1280px): height  [54px] (width auto)
- 2xl (1536px): height  [54px] (width auto)
- 3xl (1920px): height  [54px] (width auto)
- 2k (2240px): height  [54px] (width auto)
- 4k (2560px+): height  [54px] (width auto)

*/
